import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { getIcon } from "@litonarefin/utils/icons/index";
import StyleIcon from "@litonarefin/components/StyledIcon";

const Modal = ({
  children,
  onCloseModal,
  width = "350px",
  height = "180px",
  closeOutside = false,
}) => {
  const elRef = useRef(null);

  if (!elRef.current) {
    elRef.current = document.createElement("div");
  }

  useEffect(() => {
    const modalRoot = document.getElementById("jlt-modal-root");
    if (!modalRoot) {
      const root = document.createElement("div");
      root.id = "jlt-modal-root";
      document.body.appendChild(root);
    }
    const target = document.getElementById("jlt-modal-root");
    target.appendChild(elRef.current);

    return () => {
      target.removeChild(elRef.current);
    };
  }, []);

  return createPortal(
    <Wrapper>
      <ModalContent $modalWidth={width} $modalHeight={height}>
        <span
          onClick={() => onCloseModal()}
          className={`jlt-absolute jlt-cursor-pointer jlt-z-50 ${
            closeOutside ? "-jlt-top-8 jlt-right-2" : " jlt-top-4 jlt-right-[18px]"
          }`}
        >
          <StyleIcon
            {...(closeOutside ? { color: "#fff" } : {})}
            styles={{ width: "16px", height: "16px" }}
          >
            {getIcon("close")}
          </StyleIcon>
        </span>
        {children}
      </ModalContent>
    </Wrapper>,
    elRef.current
  );
};

export default Modal;

const Wrapper = styled.div.attrs(() => ({
  className:
    "jlt-fixed jlt-top-0 jlt-left-0 jlt-w-full jlt-h-full jlt-bg-[#16213e74] jlt-z-[99999999] jlt-flex jlt-justify-center jlt-items-center",
}))`
  /* animation: fadeIn 0.1s ease-out forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  } */
`;

const ModalContent = styled.div.attrs(() => ({
  className: "jlt-relative jlt-z-[99999]",
}))`
  width: ${(props) => props.$modalWidth};
  height: ${(props) => props.$modalHeight};
  max-width: ${(props) => props.$modalWidth};
  max-height: ${(props) => props.$modalHeight};
`;
